import add from 'lodash/add';
import { parseNumber } from '../../../common';
const VAT_PERCENTAGE = 0.2;

const getPercentageWithVAT = percentage => {
  return add(parseNumber(percentage), parseNumber(percentage) * VAT_PERCENTAGE);
};

export { getPercentageWithVAT };
